var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EADDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.5 18.69H25.61C23.24 18.69 21.31 16.76 21.31 14.39V11.5C21.31 10.95 20.86 10.5 20.31 10.5H16.07C12.99 10.5 10.5 12.5 10.5 16.07V24.93C10.5 28.5 12.99 30.5 16.07 30.5H23.93C27.01 30.5 29.5 28.5 29.5 24.93V19.69C29.5 19.14 29.05 18.69 28.5 18.69Z",
    fill: "#6A639C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7997 10.71C23.3897 10.3 22.6797 10.58 22.6797 11.15V14.64C22.6797 16.1 23.9197 17.31 25.4297 17.31C26.3797 17.32 27.6997 17.32 28.8297 17.32C29.3997 17.32 29.6997 16.65 29.2997 16.25C27.8597 14.8 25.2797 12.19 23.7997 10.71Z",
    fill: "#6A639C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.849c1b0c258590242f2e89f2627232d0.svg";
export { ForwardRef as ReactComponent };